import { render, staticRenderFns } from "./TrainingResults.vue?vue&type=template&id=246b0f58&"
import script from "./TrainingResults.vue?vue&type=script&lang=js&"
export * from "./TrainingResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports